import type { AmbleContent } from "../..";
import { wholesalerContactInfoCoverageAccuracy } from "../../shared/wholesaler-contact-info";

const getAffordableQuotes =
  "<p>Thank you for using Simply Business to get a quote for your small business client.</p><p>Your agent details have been submitted by Appulate in the background and will be linked by Simply Business to every quote and policy you create.</p><p>The price you received on the Appulate Platform was an indicative price and was based on your client's trade, business zip code, revenue over 12 months, and expected total payroll. We'll need additional information to complete a full quote with Harborway\u2122.</p>";

export const ambles: Record<string, AmbleContent> = {
  usa_business_get_affordable_quotes: getAffordableQuotes,
  usa_wholesaler_contact_information: wholesalerContactInfoCoverageAccuracy,
};
